// extracted by mini-css-extract-plugin
export var fullHeightState = "_5j-7";
export var headerCell = "_5j-1";
export var loadingStateCell = "_5j-4";
export var rowWrapper = "_5j-3";
export var standaloneTable = "_5j-8";
export var standaloneTableWithBodyFill = "_5j-9";
export var stateCell = "_5j-5";
export var table = "_5j-0";
export var tableBodyFiller = "_5j-6";
export var white = "_5j-2";